import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import template from './index.vdt';
import { BaseDialog } from '../dialog/base';
import { placements } from './styles';
var typeDefs = _extends({}, BaseDialog.typeDefs, {
  placement: placements
});
var defaults = function defaults() {
  return _extends({}, BaseDialog.defaults(), {
    placement: 'right',
    draggable: false
  });
};
export var Drawer = /*#__PURE__*/function (_BaseDialog) {
  _inheritsLoose(Drawer, _BaseDialog);
  function Drawer() {
    return _BaseDialog.apply(this, arguments) || this;
  }
  return Drawer;
}(BaseDialog);
Drawer.template = template;
Drawer.typeDefs = typeDefs;
Drawer.defaults = defaults;